module.exports = "<div class=\"taskbar-section\" @mousedown=\"mousedown($event);\">\n        <div class=\"app-list\">\n            <div\n                    class=\"app-item\"\n                    :class=\"{actived:app._focus}\"\n                    v-for=\"app in sortedApps\"\n                    @click=\"click(app)\"\n            >\n                <span class=\"icon {{app.icon}}\"></span>{{app.title}}\n            </div>\n        </div>\n    </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/taskbar.vue
 ** module id = 94
 ** module chunks = 0
 **/